// One address for the app (owner, 4 Nov 2026: "web.app الغى ده مش محتاجينه حاليا"): opened at a Firebase address,
// the page moves to https://yelodubai.com with the same path. Firebase Hosting itself stays - the server at
// yelodubai.com passes these same files on from it (engine/deploy/Caddyfile), so only a browser that opened the
// Firebase address is moved; localhost and yelodubai.com never are.
export const HOME = 'https://yelodubai.com';
export const FIREBASE_HOSTS = ['yelo-dubai-management.web.app', 'yelo-dubai-management.firebaseapp.com'];

/** Where the page should be instead, or null to stay. */
export function homeAddressFor(loc) {
    if (!loc || !FIREBASE_HOSTS.includes(String(loc.hostname || '').toLowerCase())) return null;
    return `${HOME}${loc.pathname || '/'}${loc.search || ''}${loc.hash || ''}`;
}
